/**
 * THIRDWEB Constants
 * Stores information related to Thirdweb React library.
 */
export const THIRDWEBConstants = Object.freeze({
    GATEWAY: {
        URLS: {
            "ipfs://": [
              "https://ipfs.io/ipfs/",
            ],
          }
    },
    CLIENT_ID: `${process.env.REACT_APP_THIRDWEB_CLIENT_ID}`
})